import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ant-row ant-form-vertical" }
const _hoisted_2 = { class: "ant-row ant-form-vertical" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-row ant-form-vertical" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-display-flex-end" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-table-column-title" }
const _hoisted_11 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_12 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.props.apresentarEmpresas)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.props.apresentarUsuarios?'ant-col ant-col-xs-24 ant-col-xl-12':'ant-col ant-col-xs-24 ant-col-xl-24')
          }, [
            _createVNode(_component_a_form_item, {
              label: "Empresas",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_empresa, {
                  varias: true,
                  codigosSelecionados: _ctx.computedEmpresasSelecionadas,
                  "onUpdate:codigosSelecionados": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedEmpresasSelecionadas) = $event)),
                  apenasAutorizadasUsuario: true
                }, null, 8, ["codigosSelecionados"])
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.props.apresentarUsuarios)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.props.apresentarEmpresas?'ant-col ant-col-xs-24 ant-col-xl-12':'ant-col ant-col-xs-24 ant-col-xl-24')
          }, [
            _createVNode(_component_a_form_item, {
              label: "Usuários",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_usuario, {
                  varios: true,
                  codigosSelecionados: _ctx.stateRegistroAtividade.filtros.usuarios,
                  "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stateRegistroAtividade.filtros.usuarios) = $event)),
                  empresas: _ctx.computedEmpresasSelecionadas
                }, null, 8, ["codigosSelecionados", "empresas"])
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_form_item, {
          label: "Período",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_range_picker, {
              class: "ss-tamanho-completo",
              value: _ctx.stateRegistroAtividade.datas,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stateRegistroAtividade.datas) = $event)),
              "show-time": { format: _ctx.UtilitarioData.formatoHoraMinutoSegundo },
              format: _ctx.UtilitarioData.formatoDataDiaMesAnoHoraMinutoSegundo,
              placeholder: ['Data inicial', 'Data final']
            }, null, 8, ["value", "show-time", "format"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_form_item, {
          label: "Recurso",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              class: "ss-tamanho-completo",
              value: _ctx.stateRegistroAtividade.filtros.recursos,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stateRegistroAtividade.filtros.recursos) = $event)),
              mode: "multiple",
              "show-search": "",
              allowClear: true,
              placeholder: "Digite para selecionar os recursos",
              "filter-option": false,
              "not-found-content": _ctx.telaBase.fetching ? undefined : null,
              options: _ctx.stateRegistroAtividade.listaRecursos,
              onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pesquisarRecurso($event)))
            }, _createSlots({ _: 2 }, [
              (_ctx.telaBase.fetching)
                ? {
                    name: "notFoundContent",
                    fn: _withCtx(() => [
                      _createVNode(_component_a_spin, { size: "small" })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["value", "not-found-content", "options"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_form_item, {
          label: "Detalhes",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "ant-input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stateRegistroAtividade.filtros.detalhe) = $event))
            }, null, 512), [
              [_vModelText, _ctx.stateRegistroAtividade.filtros.detalhe]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.filtrar && _ctx.filtrar(...args))),
          type: "button",
          class: "ant-btn ant-btn-block ant-btn-primary"
        }, " Filtrar ")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_table, {
          columns: _ctx.stateRegistroAtividade.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.stateRegistroAtividade.dados,
          rowKey: "codigo",
          pagination: false,
          scroll: { x: _ctx.props.largura , y: _ctx.props.altura},
          loading: _ctx.telaBase.carregando,
          size: "small"
        }, {
          headerCell: _withCtx(({ column }) => [
            (column.ordering)
              ? (_openBlock(), _createElementBlock("div", {
                  key: column.key,
                  class: "ss-coluna-ordenada"
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(column.title), 1),
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(), _createElementBlock("a", {
                        title: "Ordenação crescente",
                        key: 'ord-asc' + column.key,
                        class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                        onClick: ($event: any) => (_ctx.ordenarDados(column.key,'ASC'))
                      }, _hoisted_15, 10, _hoisted_13)),
                      (_openBlock(), _createElementBlock("a", {
                        title: "Ordenação decrescente",
                        key: 'ord-desc' + column.key,
                        class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                        onClick: ($event: any) => (_ctx.ordenarDados(column.key,'DESC'))
                      }, _hoisted_18, 10, _hoisted_16))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading"])
      ])
    ])
  ]))
}